import { RouteKeys, RouteParams, routes } from 'constants/routes'
import { useToast } from 'containers/ToastManager'
import { ReactNode } from 'react'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { Variant } from 'components/Toasts/Toast'

export const useShareRedirects = () => {
  const location = useLocation()
  const history = useHistory()
  const { showToast } = useToast()

  const matchKnownPath = <Key extends RouteKeys>(key: Key) =>
    matchPath<RouteParams<Key>>(location.pathname, {
      path: routes[key].template(),
      exact: false,
    })

  const isUserViewing = {
    anyShare: () => {
      const { shareID } = matchKnownPath('SHARE_VIEW')?.params || {}
      return shareID ? { shareID } : false
    },
    share: (shareIdentifier: string) =>
      matchKnownPath('SHARE_VIEW')?.params.shareID === shareIdentifier,
    workspaceTrash: (workspaceId: string) =>
      matchKnownPath('WORKSPACE_TRASH')?.params.workspaceId === workspaceId,
  }

  const redirectToDocumentsView = ({
    workspaceId,
    toast,
  }: {
    workspaceId: string
    toast?: { message: ReactNode; variant?: Variant }
  }) => {
    history.push(routes.WORKSPACE_SHARES.create({ workspaceId }))

    if (toast) {
      showToast(toast.message, toast.variant)
    }
  }

  return {
    isUserViewing,
    redirectToDocumentsView,
  }
}
